module.exports = __webpack_public_path__ + "img/align-center.6f1e7ed5.svg";